import { connect } from 'react-redux';
import SelectPlan from './SelectPlan';

import { getInsurancePlans, getDevice } from 'reducers';
import { fetchValue as fetchInsurancePlansForValue } from '../actions';
import { find as findDevice } from 'devices/actions';

const mapStateToProps = (state, props) => {
  const device = getDevice(state, props.sku);
  return {
    plans: device && getInsurancePlans(state),
    device 
  }
};

const mapDispatchToProps = {
  fetchInsurancePlansForValue,
  findDevice,
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SelectPlan);
